export enum CaptionOptions {
  NextPage = 'next',
  PreviousPage = 'previous',
  ChangeRegisterPerPage = 'changeRegisterPerPage',
}
